export const TOGGLE_PREVIEW = 'ui/TOGGLE_PREVIEW'
export const TOGGLE_SIDEBAR = 'ui/TOGGLE_SIDEBAR'
export const UPDATE_BUTTONS = 'ui/UPDATE_BUTTONS'
export const CHANGE_WALLPAPER = 'ui/CHANGE_WALLPAPER'
